export default {
    state: {
        all: [],
        filtered: [],
        selectedSite: []
    },
	actions: {
		async loadSites({ commit }) {
			await axios.get('/api/sites').then(sites => {
				commit('setSites', sites)
			}).catch(response => {
				console.error(response);
			});
		},

		async loadSite({ commit }, siteID) {
			await axios.get(`/api/site/${siteID}`).then(site => {
				commit('setSite', site.data)
			}).catch(response => {
				console.error(response);
			});
		},

	},
	mutations: {
		setSites(state, sites) {
			state.all = sites.data
			state.filtered = sites.data
		},

		setSite(state, site) {
			state.selectedSite = site;
		},

		UPDATE_SITE(state, updatedSite) {
			// Update the selected site with the new data
			state.selectedSite = {
				...state.selectedSite,
				...updatedSite
			};

			// Also update the site in the all sites array if it exists there
			const index = state.all.findIndex(site => site.id === updatedSite.id);
			if (index !== -1) {
				state.all.splice(index, 1, {
					...state.all[index],
					...updatedSite
				});
			}
		}
	},
	getters: {
		sitesSortedBy: (state) => (fields) => {
			return _.sortBy(state.all, fields);
		}
	}
};